import { Controller } from "@hotwired/stimulus"
import Stimulus from "../../shared/utils/stimulus"

class QuickButtons extends Controller {
  updateData(evt) {
    document.querySelector(evt.target.dataset.quickButtonsElement).dataset[
      evt.target.dataset.quickButtonsKey
    ] = evt.target.dataset.quickButtonsValue
  }
}

Stimulus.register(`quick-buttons`, QuickButtons)
